import { Component, type ReactNode } from 'react';
import { Alert, Container } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

interface State { error: Error | null }

export class PageErrorBoundary extends Component<{ children: ReactNode }, State> {
    constructor(props: { children: ReactNode }) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error: Error): State { return { error }; }
    render() {
        if (this.state.error) {
            return (
                <Container size={600} py="xl">
                    <Alert color="red" icon={<IconAlertCircle size={18} />} title="Ошибка приложения">
                        {this.state.error.message}
                    </Alert>
                </Container>
            );
        }
        return this.props.children;
    }
}
